<div class="unsubscribe" [style.background-image]="backgroundImageUrl()">
  <div class="unsubscribe__card">

    <div *ngIf="state === 'loading'" class="unsubscribe__block">
      <p>{{ 'SB_Loading' | translate }}</p>
    </div>

    <div *ngIf="state === 'invalid'" class="unsubscribe__block">
      <h1 class="unsubscribe__title">{{ 'SB_Unsubscribe_Title' | translate }}</h1>
      <p>{{ 'SB_Unsubscribe_Invalid' | translate }}</p>
    </div>

    <div *ngIf="state === 'ready'" class="unsubscribe__block">
      <h1 class="unsubscribe__title">{{ 'SB_Unsubscribe_Title' | translate }}</h1>
      <p>{{ 'SB_Unsubscribe_Prompt' | translate }}</p>
      <p class="unsubscribe__detail">
        <span class="unsubscribe__email">{{ info?.emailAddress }}</span>
        <span *ngIf="info?.organisationName"> &mdash; {{ info?.organisationName }}</span>
      </p>
      <button type="button" class="btn btn-primary" [disabled]="submitting" (click)="confirm()">
        {{ 'SB_Unsubscribe_Confirm' | translate }}
      </button>
    </div>

    <div *ngIf="state === 'done'" class="unsubscribe__block">
      <h1 class="unsubscribe__title">{{ 'SB_Unsubscribe_Done_Title' | translate }}</h1>
      <p>{{ 'SB_Unsubscribe_Done_Message' | translate }}</p>
      <p class="unsubscribe__detail">
        <span class="unsubscribe__email">{{ info?.emailAddress }}</span>
        <span *ngIf="info?.organisationName"> &mdash; {{ info?.organisationName }}</span>
      </p>
      <button type="button" class="btn btn-link" [disabled]="submitting" (click)="resubscribe()">
        {{ 'SB_Unsubscribe_Resubscribe' | translate }}
      </button>
    </div>

    <div *ngIf="state === 'resubscribed'" class="unsubscribe__block">
      <h1 class="unsubscribe__title">{{ 'SB_Unsubscribe_Title' | translate }}</h1>
      <p>{{ 'SB_Unsubscribe_Resubscribed' | translate }}</p>
    </div>

    <p class="unsubscribe__footer">&copy; {{ currentYear }}</p>
  </div>
</div>
